import {
  GetHierarchies,
  GetHierarchyElements
} from "../services/hierarchyService";
const requestAccountHierarchiesType = "REQUEST_ACCOUNT_HIEARCHIES";
const receiveAccountHierarchiesType = "RECEIVE_ACCOUNT_HIEARCHIES";
const requestHierarchyElementsType = "REQUEST_HIREARCHY_ELEMENT";
const receiveHierarchyElementsType = "RECEIVE_HIERARCHY_ELEMENT";
const setHierarchyElementsType = "SET_HIERARCHY_ELEMENTS";
const initialState = {
  hierarchies: [],
  hierarchyElements: [],
  loading: false,
  loadingElements: true
};

export const actionCreators = {
  requestHierarchies: hierarchyType => async (dispatch, getState) => {
    dispatch({ type: requestAccountHierarchiesType });

    const hierarchies = await GetHierarchies(hierarchyType);

    dispatch({ type: receiveAccountHierarchiesType, hierarchies: hierarchies });
  },
  requestHierarchyElements: hierarchyId => async (dispatch, getState) => {
    dispatch({ type: requestHierarchyElementsType, hierarchyId });

    const hierarchyElements = await GetHierarchyElements(hierarchyId);
    dispatch({
      type: receiveHierarchyElementsType,
      hierarchyId,
      hierarchyElements
    });
  },
  setHierarchyElements: hierarchyElements => (dispatch, getState) => {
    dispatch({
      type: setHierarchyElementsType,
      hierarchyElements
    });
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === requestAccountHierarchiesType) {
    return {
      ...state,
      loading: true
    };
  }

  if (action.type === receiveAccountHierarchiesType) {
    const { hierarchies } = action;
    return {
      ...state,
      hierarchies,
      loading: false
    };
  }

  if (action.type === requestHierarchyElementsType) {
    return {
      ...state,
      loadingElements: true
    };
  }

  if (action.type === receiveHierarchyElementsType) {
    const { hierarchyId, hierarchyElements } = action;
    return {
      ...state,
      hierarchyId,
      hierarchyElements,
      loadingElements: false
    };
  }

  if (action.type === setHierarchyElementsType) {
    const { hierarchyElements } = action;
    return {
      ...state,
      hierarchyElements
    };
  }

  return state;
};
